export const personTypes = {
    fop: 'ФОП',
    legal: 'Юр особа',
    'fiz-osoba': 'Фіз особа',
}